import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { BlockContextProvider } from './BlockContext';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function Block(props) {
  if (isEnabledBlock(props)) {
    var children = props.children,
      contextProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/_jsx(BlockContextProvider, _objectSpread(_objectSpread({}, contextProps), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.children
  });
}
function isEnabledBlock(props) {
  return !!props.blockRID && !!props.view;
}